import type { FieldDef } from "@/types/content";

import { FieldId } from "../constants";
import type { FieldValue } from "../types";
import { getFieldPresets } from "../utils";
import { PersonImageField } from "./fields/PersonImageField";
import {
  BooleanField,
  ColorField,
  ImageField,
  NumberField,
  PresetField,
  SelectField,
  TextareaField,
  TextField,
} from "./fields/PrimitiveFields";

interface Props {
  field: FieldDef;
  value: FieldValue;
  onChange: (value: FieldValue) => void;
}

export const DynamicField = ({ field, value, onChange }: Props) => {
  if (field.id === FieldId.PERSON_IMAGE) {
    return <PersonImageField field={field} value={value} onChange={onChange} />;
  }

  if (getFieldPresets(field).length > 0) {
    return <PresetField field={field} value={value} onChange={onChange} />;
  }

  switch (field.type) {
    case "image":
      return <ImageField field={field} value={value} onChange={onChange} />;
    case "video":
      return (
        <TextField
          field={{ placeholder: "https://...", ...field }}
          value={value}
          onChange={onChange}
        />
      );
    case "select":
      return <SelectField field={field} value={value} onChange={onChange} />;
    case "boolean":
      return <BooleanField field={field} value={value} onChange={onChange} />;
    case "number":
    case "slider":
      return <NumberField field={field} value={value} onChange={onChange} />;
    case "color":
      return <ColorField field={field} value={value} onChange={onChange} />;
    case "textarea":
      return <TextareaField field={field} value={value} onChange={onChange} />;
    default:
      return <TextField field={field} value={value} onChange={onChange} />;
  }
};
